import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Card, CardContent, Button, Chip, Alert, Grid
} from '@mui/material';
import { Edit, Warning } from '@mui/icons-material';
import { editorAPI } from '../../services/api';
import { useSnackbar } from '../../utils/notify';

var E = React.createElement;

export default function ViewerEditorList() {
  var sn = useSnackbar(); var notify = sn.enqueueSnackbar;
  var navigate = useNavigate();
  var fs = useState([]); var forms = fs[0]; var setForms = fs[1];
  var ld = useState(true); var loading = ld[0]; var setLoading = ld[1];

  useEffect(function() {
    editorAPI.list().then(function(r) {
      setForms(r.data.data || []);
      setLoading(false);
    }).catch(function(e) {
      notify((e.response && e.response.data && e.response.data.error) || 'Failed to load forms', {variant:'error'});
      setLoading(false);
    });
  }, []);

  if (loading) return E(Typography, {color:'text.secondary'}, 'Loading...');

  return E(Box, null,
    E(Typography, {variant:'h4', sx:{mb:1}}, 'Build Forms'),
    E(Typography, {variant:'body2', color:'text.secondary', sx:{mb:3}},
      'Edit form structure: title, description, sections and fields. Settings, deadlines and activation are managed by admins.'),

    forms.length === 0
      ? E(Alert, {severity:'info'}, 'No forms have been assigned to you for editing.')
      : E(Grid, {container:true, spacing:2},
          forms.map(function(f) {
            return E(Grid, {item:true, xs:12, sm:6, md:4, key:f.id},
              E(Card, {sx:{height:'100%', display:'flex', flexDirection:'column'}},
                E(CardContent, {sx:{flex:1}},
                  E(Typography, {variant:'h6', sx:{mb:1}}, f.title),
                  f.has_submissions
                    ? E(Chip, {icon:E(Warning, {fontSize:'small'}), label:'Has submissions — some edits restricted',
                        size:'small', color:'warning', variant:'outlined', sx:{mb:1.5}})
                    : E(Chip, {label:'No submissions yet', size:'small', variant:'outlined', sx:{mb:1.5}}),
                  f.description
                    ? E(Typography, {variant:'body2', color:'text.secondary',
                        sx:{overflow:'hidden', textOverflow:'ellipsis', display:'-webkit-box',
                          WebkitLineClamp:2, WebkitBoxOrient:'vertical'}},
                        f.description.replace(/<[^>]*>/g, ''))
                    : null),
                E(Box, {sx:{p:2, pt:0}},
                  E(Button, {variant:'contained', startIcon:E(Edit), fullWidth:true,
                    onClick:function(){ navigate('/viewer/editor/' + f.id); }}, 'Edit form'))));
          })));
}
